import { render, staticRenderFns } from "./orderLoanStatisticsList.vue?vue&type=template&id=6efc67d8&scoped=true"
import script from "./orderLoanStatisticsList.vue?vue&type=script&lang=js"
export * from "./orderLoanStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./orderLoanStatisticsList.vue?vue&type=style&index=0&id=6efc67d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc67d8",
  null
  
)

export default component.exports